import { render, staticRenderFns } from "./myAudio.vue?vue&type=template&id=19dd02a4&scoped=true"
import script from "./myAudio.vue?vue&type=script&lang=js"
export * from "./myAudio.vue?vue&type=script&lang=js"
import style0 from "./myAudio.vue?vue&type=style&index=0&id=19dd02a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd02a4",
  null
  
)

export default component.exports